// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"367e3c87","977":"c07ac956"}[chunkId] + ".chunk.js";
};